import { CounterDraft } from '@domain/types';

import {
  BaseDashboardViewState,
  INITIAL_DASHBOARD_VIEW_STATE,
  INITIAL_SETTINGS_OVERRIDES_VIEW_STATE,
  SettingsOverridesState,
} from '../documents.state';

// Extended types with timestamp for TTL caching
export type CounterDraftWithTimestamp = CounterDraft & {
  lastFetchedAt?: number;
};

export interface DraftCounterState {
  totalDraft: CounterDraftWithTimestamp;
}

export const INITIAL_DRAFT_COUNTER_STATE: CounterDraftWithTimestamp = {
  total: 0,
  identities: {},
  lastFetchedAt: undefined,
};

export interface CurrentIdentityState {
  currentIdentity?: string;
}
export interface DraftDocumentsState {
  dashboardView: BaseDashboardViewState &
    SettingsOverridesState &
    DraftCounterState &
    CurrentIdentityState;
}

export const INITIAL_DRAFT_DOCUMENTS_STATE: DraftDocumentsState = {
  dashboardView: {
    ...INITIAL_DASHBOARD_VIEW_STATE,
    settingsOverrides: INITIAL_SETTINGS_OVERRIDES_VIEW_STATE,
    totalDraft: INITIAL_DRAFT_COUNTER_STATE,
    currentIdentity: undefined,
    searchParams: {
      ...INITIAL_DASHBOARD_VIEW_STATE.searchParams,
      defaultDateRange: true,
      statuses: ['draft', 'suspended'],
      includePredictions: true,
      includePractitionerRoles: true,
      includeIntegration: true,
      includeConnectors: true,
      includeUnselectedConnectors: true,
    },
  },
};
